import { useDataChange } from 'Simple/Data.js'

import { dateShortOut } from 'Data/format.js'

/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props, data) {
  let changeReport = useDataChange({
    context: 'report',
    viewPath: props.viewPath,
  })
  return function onChange(value, change) {
    // sync up the value
    changeReport(next => {
      next.filter_values.transactions_start_date = dateShortOut(value.from)
      next.filter_values.transactions_end_date = dateShortOut(value.to)
    })
  }
}
